<template>
    <ion-page>
        <ion-header >
        <ion-toolbar>
          <ion-title class="ion-padding-bottom ion-text-center">
            <h3>Insecal Inspección SL</h3>
        </ion-title>
        </ion-toolbar>
      </ion-header>
        <ion-content>
            <div>
                <ion-row>
                    <ion-col size="12" class="ion-text-center">
                        <h3>Terminos y Condiciones</h3>
                        <hr>
                    </ion-col>
                    <ion-col size="12" v-show="!datos.acepta_tyc">
                            <!-- used `style="height: 100vh;"` because without it in the Firefox 89 and Chrome 91 (June 2021) the `vue-pdf-app` is not rendering on the page, just empty space without any errors (since `vue-pdf-app` does not have height and it is the top tag in the generated markup ) -->
                            <!-- or you can just wrap `vue-pdf-app` in <div> tag and set height for it via CSS (like in `Script tag (unpkg)` example below) -->
                            <vue-pdf-app style="height: 60vh;" pdf="/terminos_y_condiciones.pdf"></vue-pdf-app>
                    </ion-col>
                    <ion-col size="12" >
                        <ion-item :lines="'none'" >
                            <ion-checkbox slot="start" @ion-change="showPasswordMessage()" v-model="datos.acepta_tyc" aria-label="Acepto Terminos y Condiciones"></ion-checkbox>
                            <ion-label>Acepto Terminos y Condiciones</ion-label>
                        </ion-item>
                    </ion-col>
                    <ion-col size="12" v-show="datos.acepta_tyc">
                        <ion-card color="light">
                            <ion-card-content >
                                <ion-item color="light" class="ion-padding-bottom">
                                    <ion-input type="password" label="Nuevo Password" label-placement="floating" v-model="datos.nuevoPassword"></ion-input>
                                </ion-item>
                                <ion-item color="light" v-show="datos.nuevoPassword!==null ">
                                    <ion-input type="password"  label="Repita su password" label-placement="floating"  v-model="datos.nuevoPasswordVerificacion"></ion-input>
                                </ion-item>
                                <ion-item :lines="'none'" v-show="datos.nuevoPasswordVerificacion!==null && datos.nuevoPassword!==datos.nuevoPasswordVerificacion">
                                    <ion-label color="danger">Los password no coinciden!</ion-label>
                                </ion-item>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                    <ion-col size="12" class="ion-margin-start" v-show="datos.acepta_tyc && (datos.nuevoPassword && datos.nuevoPasswordVerificacion) && (datos.nuevoPassword === datos.nuevoPasswordVerificacion) ">
                        <ion-button @click="acceptTermsAndConditions(datos)">
                            <ion-spinner name="dots" v-show="loading"></ion-spinner> 
                            <ion-label v-show="!loading">Guardar</ion-label>
                        </ion-button>
                    </ion-col>
                </ion-row>

            </div>
        </ion-content>
    </ion-page>    
</template>
<script setup lang="ts" >
import { 
    IonPage, 
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonRow,
    IonCol, 
    IonCheckbox,
    IonLabel,
    IonItem,
    IonInput, 
    IonButton, 
    IonSpinner,
    IonCard,
    IonCardContent 
} from '@ionic/vue';
import { ref } from 'vue';
import VuePdfApp from "vue3-pdf-app";
// import this to use default icons for buttons
import "vue3-pdf-app/dist/icons/main.css";
import { showAlert } from '@/helpers/alertHelper';
import { useUser } from '@/composables/useUser';


const datos = ref({acepta_tyc:false, nuevoPassword:'',nuevoPasswordVerificacion:''});
const loading = ref(false);
const { acceptTermsAndConditions } = useUser();

const showPasswordMessage = () => {
    showAlert('Aviso','Deberá cambiar el password para que se habilite su usuario.');
};

</script>